import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { UserDto } from '@/models/dtos/userDto'
import { EndpointsAdmin } from '@/admin/services/_endpoints.admin'
import axios from 'axios'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import { RoleDto } from '@/models/dtos/roleDto'

export abstract class UserAdminService {
  static async get(userId: string): Promise<UserDto> {
    const result = await axios
      .get<BaseResponseDto<UserDto>>(EndpointsAdmin.account.get, {
        params: {
          userId
        }
      })

    if (!result?.data?.dto) throw new Error('Cannot get user')

    return result.data.dto
  }

  static async getAll(): Promise<UserDto[]> {
    const result = await axios
      .get<BaseResponseDto<UserDto[]>>(EndpointsAdmin.account.getAll)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async add(user: UserDto): Promise<string> {
    const result = await axios
      .post<BaseResponseDto<string>>(EndpointsAdmin.account.add, user)

    return result.data.dto!
  }

  static async edit(user: UserDto): Promise<void> {
    await axios
      .put<BaseResponseDto<any>>(EndpointsAdmin.account.edit, user)
  }

  static async remove(userId: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(EndpointsAdmin.account.remove, {
        params: {
          userId
        }
      })
  }

  static async GetEmployeeTypes(): Promise<EmployeeTypeDto[]> {
    const result = await axios.get<BaseResponseDto<EmployeeTypeDto[]>>(EndpointsAdmin.account.getEmployeeTypes)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async GetRoles(): Promise<RoleDto[]> {
    const result = await axios.get<BaseResponseDto<RoleDto[]>>(EndpointsAdmin.account.getRoles)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async GetUserName(userName: string): Promise<string> {
    const result = await axios.get<BaseResponseDto<string>>(EndpointsAdmin.account.getUserName, {
      params: {
        userName
      }
    })

    return result.data.dto!
  }

  static async resetPassword(userId: string, newPassword: string): Promise<void> {
    await axios
      .get<BaseResponseDto<any>>(EndpointsAdmin.account.resetPassword, {
        params: {
          userId,
          newPassword
        }
      })
  }
}
